export default __webpack_public_path__ + "static/media/jobIcon-dark.929cd3f6.svg";